export default __webpack_public_path__ + "static/media/aqua.0ed6a045.gif";